import { CourseProduct } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { readHasActiveOffering, readIsUsedInActivePackage } from "./productDtoHelpers";
import { getAllUnitTypes } from "./getAllUnitTypes";

function getCourseProductsArray(result: any): any[] {
    if (Array.isArray(result)) return result;
    if (Array.isArray(result?.data)) return result.data;
    if (Array.isArray(result?.items)) return result.items;
    if (Array.isArray(result?.result)) return result.result;
    return [];
}

export async function getCourseProducts(divisionId: number) {
    const localApi = await getLocalApi();

    const list = await localApi.fetchList(
        apiConfig.courses_get_all.replace("{divisionId}", divisionId.toString()),
        mapCourseProducts,
        "Failed to fetch course products",
        getCourseProductsArray
    );
    return attachUnitTypeTextToCourses(list);
}

function mapCourseProducts(courseProduct: any): CourseProduct {
    const hasClosureDate = courseProduct.closureDate != null && courseProduct.closureDate !== '';
    const activeFromApi = typeof courseProduct.active === 'boolean' ? courseProduct.active : true;
    const active = !hasClosureDate && activeFromApi;
    return {
        id: courseProduct.productId,
        name: courseProduct.productName,
        lastModifiedDate: courseProduct.lastModifiedDate,
        lastUpdatedBy: courseProduct.lastModifiedBy,
        division: courseProduct.divisionId,
        divisionText:courseProduct.division,
        intensityId: courseProduct.courseIntensityId,
        intensityText:  courseProduct.courseIntensityText,
        entityUpdate: courseProduct.entityUpdate,
        accountCategoryText: courseProduct.accountCategoryText,
        productCategoryText: courseProduct.productCategoryText,
        languageId: courseProduct.courseLanguageId,
        languageText: courseProduct.courseLanguageText,
        active,
        closureDate: courseProduct.closureDate ? new Date(courseProduct.closureDate) : null,
        productCategoryId: courseProduct.productCategoryId,
        accountCategoryId: courseProduct.accountCategoryId,
        CourseProduct: courseProduct.CourseProduct || false,
        excludedBookingSystemIds: [],
        minimumAge: courseProduct.minimumAge ?? null,
        minimumWeeks: courseProduct.minimumWeeks ?? null,
        unitTypeId:
          courseProduct.unitTypeId != null && String(courseProduct.unitTypeId).trim() !== ""
            ? Number(courseProduct.unitTypeId)
            : undefined,
        unitTypeText:
          courseProduct.unitTypeText != null
            ? String(courseProduct.unitTypeText)
            : courseProduct.unitTypeName != null
              ? String(courseProduct.unitTypeName)
              : undefined,
        hasActiveOffering: readHasActiveOffering(courseProduct),
        isUsedInActivePackage: readIsUsedInActivePackage(courseProduct),
    };
}

export async function attachUnitTypeTextToCourses(
  courses: CourseProduct[]
): Promise<CourseProduct[]> {
  if (!courses?.length) return courses ?? [];
  const byId = new Map<number, string>();
  try {
    const unitTypes = await getAllUnitTypes();
    for (const u of unitTypes ?? []) {
      const id = Number((u as { id?: unknown }).id);
      const name = String((u as { name?: unknown }).name ?? "").trim();
      if (Number.isFinite(id) && id > 0 && name) byId.set(id, name);
    }
  } catch {
    return courses;
  }
  return courses.map((row) => {
    const existing = (row.unitTypeText ?? "").trim();
    if (existing) return row;
    const uid = row.unitTypeId;
    if (uid == null || !Number.isFinite(Number(uid)) || Number(uid) <= 0) return row;
    const resolved = byId.get(Number(uid));
    return resolved ? { ...row, unitTypeText: resolved } : row;
  });
}